export default {
  // 审批前台信息
  approval: {
    launched: 'launched myself',
    waitme: 'wait for my approval',
    haveApproval: 'I have approval',
    ccme: 'carbon copy to me',
    theme: 'theme',
    applytime: 'application time',
    closingTime: 'closing time',
    version: 'version',
    currentApproverUser: 'current approver',
    type: 'type',
    status: 'approval status',
    addApproval: 'the new approval',
    nextApprover: 'next approver',
    chooseMember: 'choose membership',
    chooseDepartment: 'choose department',
    dynamicParameter: 'dynamic parameter',
    pendingApproval: 'the approval is pending',
    approvaling: 'under approval',
    approvalPast: 'approved',
    papprovalReject: 'approval to reject',
    rescinded: 'had rescinded',
    toBeInitiated: 'to be initiated',
    toBeSubmit: 'to submit',
    transTo: 'has been passed on to',
    admin: 'administrator',
    nodeApproverFrom: 'node approver from',
    modifiedTo: 'modified to',
    alreadyWaited: 'already waited for',
    pleaseSignHere: 'please sign here by hand',
    handSignature: 'handwritten signature',
    inner: 'inner',
    duplicateData: 'duplicate data',
    pleaseCheck: 'please check it',
    pass: 'pass',
    reject: 'reject',
    passOn: 'Transfer',
    CC: 'carbon copy',
    urge: 'Remind',
    revoke: 'revoke',
    originalResume: 'the original resume',
    unknown: 'unknown',
    approvalProcess: 'approval process',
    copyPerson: 'people who copied',
    ruleCondition: 'rule condition',
    passAndEnd: 'passed and over',
    passAndTransfer: 'pass and transfer',
    needAppointNextApprlval: 'the next approver needs to be designated',
    signature: 'signature',
    clickSignature: 'click on the signature',
    rejectionMode: 'mode of rejection',
    rejectedNode: 'the reject node',
    approvalOpinion2001:
      'Please enter your dismissed suggestions (no more than 200 words, not required)',
    approvalOpinion200:
      'Please enter your approval opinions (no more than 200 words, not required)',
    approvalOpinion501: 'Please enter the reminder (no more than 50 words)',
    approvalOpinion502:
      'Please enter the reason for transferring (no more than 50 words, not required)',
    urgeReason: 'urge reason',
    approvalOpinion: 'approval opinion',
    passOnReason: 'the reason to pass on',
    cexiaohou01:
      'Upon cancellation, the approval will be withdrawn from the approver and cc, and the approval process will be terminated.',
    determineRevoke: 'Are you sure you want to cancel it?',
    Approver: 'approver',
    nextStep: 'next step',
    passFreeFlow: 'pass free flow',
    approverNotEmpty: 'The approver cannot be blank',
    approvalSuccess: 'approval success',
    passOnSuccess: 'transfer success',
    urgeSuccess: 'urge success',
    revokeSuccess: 'revoke success',
    CCSuccess: 'cc success',
    rejectSuccess: 'reject success',
    urgeNotEmpty: 'The reason for the urge cannot be empty',
    copyPersonNotEmpty: 'The cc cannot be empty',
    rejectNodeNotEmpty: 'The reject node cannot be empty',
    chooseApprovalType: 'choose approval type',

    // 2020-11-16增加新的國家化字段
    dismissApproval: 'Approval free - the system will approve automatically',
    intelligentRobot: 'intelligent robot',
    rejectionContent: 'Reasons for rejection'
  }
}
